import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { CharmControl, CharmControlColorPattern } from 'owa-charmcontrol';
import { getPalette } from 'owa-theme';

export default observer(function BucketMenuItem({
    item,
    dismissMenu,
}: {
    item: IContextualMenuItem;
    dismissMenu: () => void;
}) {
    const {
        text,
        data: { charmId },
        onClick,
    } = item;

    const onItemClick = React.useCallback(
        (ev: React.MouseEvent<HTMLButtonElement>) => {
            onClick?.(ev, item);
            dismissMenu();
        },
        [onClick, item, dismissMenu]
    );

    const palette = getPalette();
    const charmColorProps = {
        colorPattern: CharmControlColorPattern.Normal,
        calPrimary: palette.neutralPrimary,
    };

    return (
        <button className={styles.bucketItem} onClick={onItemClick} role="menuitem">
            {!!charmId ? (
                <CharmControl
                    iconId={charmId}
                    className={styles.charmIcon}
                    colorProps={charmColorProps}
                />
            ) : (
                <div className={styles.charmIcon} />
            )}
            <div>{text}</div>
        </button>
    );
});
